(function (window, angular, undefined) {
    angular.module('formApp')
        .directive('productSummary', ['FormService', 'formData', 'dataUtils', 'errorHandler', '$q','$rootScope', '$http', '$filter', function (formService, formData, dataUtils, errorHandler, $q,$rootScope, $http, $filter) {
            return {
                restrict: 'EA',
                link: function ($scope, element, attr) {
                    $scope.c4lTitle = attr.c4lTitle;   
                    $scope.essentialTitle = attr.essentialTitle;
                    $scope.rabbitTitle = attr.rabbitTitle;
                    $scope.editable = !!attr.editable;
                    $scope.charitable = !!attr.charitable;
                    $scope.iddDocs = attr.iddDocs === 'true';
                    $scope.exclusions = attr.exclusions === 'true';

                    $scope.onlineDiscount = false;
                    $scope.monthFree = false;
                    $scope.firstFree = false;
                    
                    var requests = [],
                        products,
                        ipids = [];                   

                    function clearRequest(request) {
                        requests.splice(requests.indexOf(request), 1);
                    }
                    
                    function cancel() {
                        if (requests) {
                            angular.forEach(requests, function(request) {
                                request.cancel();
                                clearRequest(request);
                            });
                        }
                    }

                    function convertCovers(obj) {
                        var returnObj = {};
                        obj.forEach(function(item) {
                            if (item.sectionLimit && item.sectionLimit !== "0") {
                                returnObj[item.sectionId] =  {
                                    sectionLimit: $filter('currency')(item.sectionLimit, "£", 0),
                                    amount: item.sectionOptional === 'Y' ? 'Optional cover' : $filter('currency')(item.sectionLimit, "£", 0),
                                    excess: $filter('currency')(item.sectionFlatXs, "£", 0) + (item.sectionPctXs !== '0' ? ' + ' + item.sectionPctXs + '%' : '')
                                };
                            }
                        });
                        return returnObj;
                    }

                    function getSummarySuccess(response) {
                        if(response === 'CANCELLED') {
                            return;
                        }
                        products = response.data.products;
                        $scope.ifsPetData = [];
                        formData.pets.forEach(function(item) {
                            var pet = item;

                            // set c4L/essential flags
                            if (pet.chosenCover) {
                                switch (pet.chosenCover.productLine.toLowerCase()) {
                                    case 'essential':
                                        $scope.hasEssentialCover = true;
                                        break;
                                    case 'c4l':
                                        $scope.hasC4lCover = true;
                                        break;
                                    case 'rabbit':
                                        $scope.hasC4lCoverRabbit = true;
                                        break;
                                }
                            } 

                            // update products data
                            // TODO - also used in step3 controller - refactor into common util
                            pet.cc = {};
                            pet.cc.hasC4l = true;
                            angular.forEach(products, function (value, key) {
                                if (pet.uri === value.pet) {
                                    if (value.covers) {
                                        value.formattedCovers = convertCovers(value.covers);
                                    }
                                    if (value.id === 'DVA' || value.id === 'CVA') {
                                        pet.cc.essential = value;
                                    }
                                    if (value.id === 'DCA'|| value.id === 'CCA'|| value.id === 'RCA') {
                                        pet.cc.classic = value;
                                        if (value.unavailable) {
                                            pet.cc.hasC4l = false;
                                        }
                                    }
                                    if (value.id === 'DCB' || value.id === 'CCB') {
                                        pet.cc.classicPlus = value;
                                        if (value.unavailable) {
                                            pet.cc.hasC4l = false;
                                        }
                                    }
                                    if (value.id === 'DCC' || value.id === 'CCC') {
                                        pet.cc.ultimate = value;
                                        if (value.unavailable) {
                                            pet.cc.hasC4l = false;
                                        }
                                    }
                                }
                            });

                            // get totals
                            var ifsPet = [];
                            if (formData.runningTotals && formData.runningTotals.pets) {
                                ifsPet = formData.runningTotals.pets.filter(function(item) {
                                   return pet.uri === item.pet;
                                });
                            } 
                            if (ifsPet.length) {
                                pet.annualPremium = ifsPet[0].annualPremium;
                                pet.monthlyPremium = ifsPet[0].monthlyPremium;
                                pet.upgradeAnnualPremium = ifsPet[0].upgradeAnnualPremium;
                                pet.upgradeMonthlyPremium = ifsPet[0].upgradeMonthlyPremium;
                                pet.totalAnnual = ifsPet[0].totalAnnual;
                                pet.totalMonthly = ifsPet[0].totalMonthly;
                            }
                            $scope.ifsPetData.push(pet);
                        });
                        $rootScope.gaPetData =  $scope.ifsPetData;
                        // update total for display outside directive
                        formData.totals = {
                            total: response.data.total,
                            monthlyTotal: response.data.monthlyTotal,
                            firstInstallment: response.data.firstInstallment,
                            subsequentInstallments: response.data.subsequentInstallments
                        };

                        // set total amount depending on whether charitable donations should be displayed
                        $scope.ifsPetData.total = !$scope.charitable && response.data.totalWithoutCharity ? response.data.totalWithoutCharity : response.data.total;

                        $scope.ifsPetData.monthlyTotal = $scope.charitable && response.data.firstInstallment ? response.data.total : response.data.monthlyTotal || response.data.subsequentInstallments;
                        $scope.ifsPetData.charitableDonation = response.data.charitableDonation;
                        $scope.ifsPetData.firstInstallment = response.data.firstInstallment;
                        $scope.ifsPetData.subsequentInstallments = response.data.subsequentInstallments;

                        // check if all pets have a discount value
                        var allHaveCover = true;
                        $scope.ifsPetData.forEach(function(pet) {
                            if (!pet.annualPremium) {
                                allHaveCover = false;
                            }
                        });

                        if (allHaveCover) {
                            sessionStorage.setItem('hideDiscount', true);
                        }

                        // work out discounts
                        if(response.data.hasOwnProperty('discountFromRadar') && allHaveCover) {

                            var onlineDiscount,
                                multipetDiscount,
                                firstFree;

                            // show instalments value step 3
                            $scope.instalments = response.data.noOfinstalments;
                            
                            // check percentage discount (1 month free now a hybrid will show percent not month)
                            if (response.data.discountType === 'PERCENT') {   

                                $scope.onlineDiscountValue = response.data.discountValue;

                                // check online discount and show value
                                if(response.data.appliedDiscounts[0].discountCode) {
                                    $scope.onlineDiscount = true;
                                    if(response.data.appliedDiscounts[1] === undefined){
                                        $rootScope.$broadcast("discountApplied", {type:'Online',value: response.data.discountValue});  
                                    }

                                    onlineDiscount = response.data.appliedDiscounts.filter(function(discount) {
                                        return discount.discountCode === 'ONLINE';
                                    });
                                    $scope.ifsPetData.monthlyDiscount = onlineDiscount[0].discountMonthlyWithIpt;
                                    $scope.ifsPetData.annualDiscount = onlineDiscount[0].discountAnnualWithIpt;    
                                }
    
                                // check other discounts and show values
                                if(response.data.appliedDiscounts[1] !== undefined){

                                    // check month free discount 
                                    if(response.data.appliedDiscounts[1].discountCode === 'MFD') {
                                        $scope.firstFree = true;

                                        $rootScope.$broadcast("discountApplied",  {
                                            type:'OneMonthFree'
                                        });  

                                        firstFree = response.data.appliedDiscounts.filter(function(discount) {
                                            return discount.discountCode === 'MFD';
                                        });  
                                        $scope.ifsPetData.monthlyFirstFree = firstFree[0].discountMonthlyWithIpt;
                                        $scope.ifsPetData.annualFirstFree = firstFree[0].discountAnnualWithIpt;
                                    }

                                    // check multipet discount
                                    if(response.data.appliedDiscounts[1].discountCode === 'MPD') {
                                        multipetDiscount = response.data.appliedDiscounts.filter(function(discount) {
                                            return discount.discountCode === 'MPD';
                                        });
                                        if(multipetDiscount.length > 0) {
                                            $scope.ifsPetData.multipetMonthlyDiscount = multipetDiscount[0].discountMonthlyWithIpt;
                                            $scope.ifsPetData.multipetAnnualDiscount = multipetDiscount[0].discountAnnualWithIpt;
                                        }                                        
                                    }                              
                                }
                            }

                            // check campaign code 2 months free
                            if (response.data.discountType === 'MONTH') {
                                $scope.monthFree = true;
                                $scope.onlineDiscountValue = response.data.discountValue;
                                onlineDiscount = response.data.appliedDiscounts.filter(function(discount) {
                                    return discount.discountCode === 'MFD';
                                });
                                $scope.ifsPetData.monthlyDiscount = onlineDiscount[0].discountMonthlyWithIpt;
                                $scope.ifsPetData.annualDiscount = onlineDiscount[0].discountAnnualWithIpt;
                                $rootScope.$broadcast("discountApplied", {
                                    type:'TwoMonthFree'
                                });         
                            }
                            
                            // check campaign code multi pet discount
                            multipetDiscount = response.data.appliedDiscounts.filter(function(discount) {
                                return discount.discountCode === 'MPD';
                            });
                            if(multipetDiscount.length > 0) {
                                $scope.ifsPetData.multipetMonthlyDiscount = multipetDiscount[0].discountMonthlyWithIpt;
                                $scope.ifsPetData.multipetAnnualDiscount = multipetDiscount[0].discountAnnualWithIpt;
                            }  
             
                        }

                        if ($scope.exclusions) {
                            // check for pets with exclusions
                            var petsWithExclusions = [];
                            var petsExclusionsGender = [];
                            formData.pets.forEach(function(pet) {
                                if (pet.extraQuestions.signsOfIllnessOrInjuryUwq === 'Y' || pet.extraQuestions.everSeenByVet === 'Y' ||
                                    pet.extraQuestions.beenInsuredBefore === 'Y' || pet.extraQuestions.insuranceDeclinedBefore === 'Y') {
                                    // make first character capital of name
                                    var name = pet.details.name;
                                    var nameCapitalized = name.charAt(0).toUpperCase() + name.slice(1);
                                    petsWithExclusions.push(nameCapitalized);
                                    // get gender of excluded pet
                                    var gender = pet.details.sex;
                                    petsExclusionsGender.push(gender);
                                }
                            });

                            var excludedPets = dataUtils.petNamesList(petsWithExclusions);
                            $scope.excludedPets = excludedPets;

                            // pass data to UI for exclusion text
                            $scope.petsWithExclusions = petsWithExclusions;
                            $scope.petsExclusionsGender = petsExclusionsGender;
                        }

                    }

                    function errorCallback(data) {
                        errorHandler.reportErrors(data,'redirect');
                    }

                    function getSummary() {
         
                        $scope.hasEssentialCover = false;
                        $scope.hasC4lCover = false;
                        $scope.hasC4lCoverRabbit = false;
                        cancel();
                        var totalsPromise = formService.getRunningTotals();
                        requests.push(totalsPromise);
                        totalsPromise.then(function(response) {
                            if(response && response.data) {
                                formData.runningTotals = response.data;
                            }
                        }).catch(errorCallback);
                    }

                    function getIpids() {
                        dataUtils.getIpids();
                    }

                    // getSummary();
                    
                    if ($scope.iddDocs) {
                        getIpids();
                    }
                   

                    $scope.getIpid = function(ipid) {
                        return dataUtils.getIpid(ipid);
                    };

                    $scope.$on('updateSummary', function(data) {
                        getSummary();
                    });

                    $scope.$watch('formData.runningTotals', function(newVal, oldVal) {
                        if (newVal) {                         
                            $scope.hasEssentialCover = false;
                            $scope.hasC4lCover = false;
                            $scope.hasC4lCoverRabbit = false;
                            getSummarySuccess({data: newVal});
                          
                        }
                    });

                },
                templateUrl: 'directives/product-summary/templates/product-summary.html'
            };
        }]);
})(window, window.angular);